import { Colors } from "@/constants/Colors";
import { FontFamilies } from "@/constants/Typography";
import { StyleSheet } from "@/utils/appStyleSheet";
import React from "react";
import { ScrollView, Text, TouchableOpacity, View } from "react-native";

export interface UnderlineTabOption {
  key: string;
  label: string;
  emoji: string;
}

interface UnderlineTabBarProps {
  tabs: UnderlineTabOption[];
  activeKey: string;
  onTabSelect: (key: string) => void;
}

export function UnderlineTabBar({
  tabs,
  activeKey,
  onTabSelect,
}: UnderlineTabBarProps) {
  return (
    <View style={styles.tabBar}>
      <ScrollView
        horizontal
        showsHorizontalScrollIndicator={false}
        contentContainerStyle={styles.tabBarContent}
      >
        {tabs.map((tab) => {
          const isActive = tab.key === activeKey;
          return (
            <TouchableOpacity
              key={tab.key}
              style={[styles.tab, isActive && styles.tabActive]}
              onPress={() => onTabSelect(tab.key)}
              activeOpacity={0.7}
            >
              <Text
                style={[styles.tabEmoji, !isActive && styles.tabTextInactive]}
              >
                {tab.emoji}
              </Text>
              <Text
                style={[styles.tabLabel, !isActive && styles.tabTextInactive]}
              >
                {tab.label}
              </Text>
            </TouchableOpacity>
          );
        })}
      </ScrollView>
    </View>
  );
}

const styles = StyleSheet.create({
  tabBar: {
    borderBottomWidth: 1,
    borderBottomColor: "#E5E7EB",
  },
  tabBarContent: {
    flexDirection: "row",
    paddingHorizontal: 4,
    flexGrow: 1,
    justifyContent: "center",
  },
  tab: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
    height: 52,
    paddingHorizontal: 12,
  },
  tabActive: {
    borderBottomWidth: 4,
    borderBottomColor: Colors.primary,
  },
  tabEmoji: {
    fontSize: 16,
    color: "#161D14",
  },
  tabLabel: {
    fontSize: 15,
    fontFamily: FontFamilies.Inter.Medium,
    color: "#161D14",
  },
  tabTextInactive: {
    color: "rgba(22, 29, 20, 0.5)",
  },
});
